import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import constants from '@/app-configs/constants'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: 'da',
  fallbackLocale: 'da',
  silentTranslationWarn: true,
  silentFallbackWarn: true,
})

async function loadLocaleMessages() {
  const response = await axios.get(`${constants.debtiaappUrl}/translations/get-translations`)
  // const response = await axios.get('/translations/get-translations')
  for (const [lang, trans] of Object.entries(response.data.data)) {
    i18n.setLocaleMessage(lang, trans)
  }
}

(function checkLocalStorageLocale() {
  const locale = localStorage.getItem('locale')
  if (locale) i18n.locale = locale
}())

loadLocaleMessages()

export default i18n
